import { useMemo } from 'react';

import { getRolePermissions } from '@/shared/lib/permissions/rolePermissions';

import { useAuthStore } from '@/entities/auth';
import type { Role } from '@/entities/auth';

export const useMenuPermissions = () => {
  const { roles } = useAuthStore();

  const hasRoutePermission = useMemo(() => {
    return (routePath: string): boolean => {
      if (!roles || roles.length === 0) return false;

      const customPermissions = getRolePermissions();

      if (customPermissions) {
        const userRoles = roles.filter((role): role is Role => Boolean(role) && typeof role === 'string');

        return userRoles.some((role) => {
          const allowedRoutes = customPermissions[role] || [];
          return allowedRoutes.some((route) => routePath === route || routePath.startsWith(route + '/'));
        });
      }

      return true;
    };
  }, [roles]);

  return { hasRoutePermission };
};
